<template>
  <div>
    <b-button squared variant="cms_main" type="button" v-b-modal.modalSalesModal
      ><b-icon icon="plus-circle" class="mr-2"></b-icon>新增業務</b-button
    >
    <b-alert class="mt-4" variant="warning" show
      ><b-icon icon="exclamation-diamond-fill" class="mr-2"></b-icon
      >注意：停用業務後即可刪除業務，刪除後該業務訂單將不能更改，請注意訂單是否都已成交完成。</b-alert
    >
    <div class="pt-4">
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的業務"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(zones)="data">
          {{ data.item.zones[0].aliases_name }}
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>

      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="items"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的業務"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="row.toggleDetails"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="3"><b>姓名</b></b-col>
              <b-col>{{ row.item.name }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>手機號碼</b></b-col>
              <b-col>{{ row.item.telephone }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>業務區域</b></b-col>
              <b-col>{{ row.item.zones[0].aliases_name }}</b-col>
            </b-row>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="cms_main"
                  @click="row.toggleDetails"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>

      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 cms_main"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      id="modalSalesModal"
      :title="modal_title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      @ok="onSubmit"
      @show="showModal"
      @hidden="hiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="姓名"
          label-for="salesName"
          invalid-feedback="請填寫姓名"
          :state="state.name"
          class="required"
        >
          <b-form-input
            id="salesName"
            class="rounded-0"
            v-model="form.name"
            type="text"
            required
            placeholder="業務姓名"
            :state="state.name"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="手機號碼"
          label-for="salesTelephone"
          :invalid-feedback="invalidFeedbackTelephone"
          :state="state.telephone"
          class="required"
        >
          <b-form-input
            id="salesTelephone"
            class="rounded-0"
            v-model="form.telephone"
            type="text"
            required
            placeholder="手機號碼"
            :state="state.telephone"
            :readOnly="telephone_readOnly"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="選擇業務區域"
          label-for="salesZone"
          invalid-feedback="請選擇業務區域"
          :state="state.zones"
          class="required"
        >
          <select
            id="salesZone"
            class="custom-select rounded-0"
            v-model="form.zone_alias_id[0]"
            :class="{ 'is-invalid': state.zones === false }"
          >
            <option :value="undefined" selected disabled>請選擇</option>
            <option
              v-for="val in zones_list"
              :key="val.aliases_id"
              :value="val.aliases_id"
              :disabled="val.disabled"
            >
              {{ val.aliases_name }}</option
            >
          </select>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="cms_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Swal, Toast } from "@/plugins/sweetalert2.js";
import { Account, Zone } from "@/assets/api/cms.js";

export default {
  name: "Salesman",
  props: ["isMobile", "token"],
  data() {
    return {
      currentPage: 1,
      edit_id: null,
      fields: [
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "telephone",
          label: "手機號碼",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "zones",
          label: "業務區域",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      filter: null,
      filterOn: ["name"],
      form: {
        job_title: "",
        name: "",
        telephone: "",
        zone_alias_id: [],
        role: "Sales"
      },
      isEdit: false,
      isModalShow: false,
      items: null,
      modal_title: "新增業務",
      perPage: 10,
      state: {
        name: null,
        telephone: null,
        zones: null
      },
      totalRows: null,
      zones_list: [],
      telephone_readOnly: false,
      invalidFeedbackTelephone: "請填寫手機號碼"
    };
  },
  created() {
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.$route.query.search;
    this.getAccount();
    Zone.get("", this.token)
      .then(res => {
        if (res.status <= 201) {
          res.data.forEach(val => {
            this.zones_list.push({
              aliases_id: val.id,
              aliases_name: val.aliases_name,
              disabled: false
            });
          });
          this.zonesDisabled();
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    form: {
      handler: function() {
        if (this.isModalShow && this.isEdit) {
          this.checkFormState();
        }
      },
      deep: true
    }
  },
  methods: {
    getAccount() {
      Account.get("", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.items = res.data.Sales;
            this.totalRows = this.items.length;
          } else {
            Toast.fire({
              icon: "error",
              title: "業務資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    zonesDisabled() {
      this.zones_list.forEach(val => {
        this.items.forEach(item => {
          if (val.aliases_id == item.zones[0].aliases_id) {
            val.disabled = true;
          }
        });
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    changeStatus(ele, id) {
      if (!document.getElementById(ele).checked) {
        Swal.fire({
          title: "更改為停用狀態",
          text: "確定要停用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "停用"
        }).then(result => {
          if (result.value) {
            Account.status(id, { status: 0 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = false;
                  this.getAccount();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = true;
                }
              })
              .catch(error => {
                console.error(error);
                document.getElementById(ele).checked = true;
              });
          } else {
            document.getElementById(ele).checked = true;
          }
        });
      } else {
        Swal.fire({
          title: "更改為啟用狀態",
          text: "確定要啟用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "啟用"
        }).then(result => {
          if (result.value) {
            Account.status(id, { status: 1 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = true;
                  this.getAccount();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = false;
                }
              })
              .catch(error => {
                console.error(error);
                document.getElementById(ele).checked = true;
              });
          } else {
            document.getElementById(ele).checked = false;
          }
        });
      }
    },
    resetForm() {
      this.modal_title = "新增業務";
      this.isEdit = false;
      this.edit_id = null;

      this.state.name = null;
      this.state.telephone = null;
      this.state.zones = null;

      this.form.name = "";
      this.form.telephone = "";
      this.form.zone_alias_id = [];
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.invalidFeedbackTelephone = "請填寫手機號碼";
      this.form.name ? (this.state.name = null) : (this.state.name = false);
      this.form.telephone
        ? (this.state.telephone = null)
        : (this.state.telephone = false);
      this.form.zone_alias_id.length
        ? (this.state.zones = null)
        : (this.state.zones = false);
    },
    edit(id) {
      this.resetForm();
      this.isEdit = true;
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalSalesModal", "#btnShow");
    },
    dele(id) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除此業務嗎？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Account.delete(id, this.token)
            .then(res => {
              if (res.status <= 201) {
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
                this.getAccount();
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    showModal() {
      this.isModalShow = true;
      this.zonesDisabled();
      if (this.isEdit) {
        this.modal_title = "編輯業務";
        this.telephone_readOnly = true;
        Account.get(this.edit_id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.form.name = res.data.name;
              this.form.telephone = res.data.telephone;
              this.form.zone_alias_id.push(res.data.zones[0].aliases_id);
              this.zones_list.forEach(val => {
                if (val.aliases_id == this.form.zone_alias_id[0]) {
                  val.disabled = false;
                }
              });
            } else {
              Toast.fire({
                icon: "error",
                title: "業務資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.resetForm();
        this.telephone_readOnly = false;
      }
    },
    hiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const value of Object.keys(this.state)) {
        if (this.state[value] === false) {
          return;
        }
      }
      let newData = Object.assign({}, this.form);
      if (this.isEdit) {
        delete newData.telephone;
        Account.update(this.edit_id, newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
              this.getAccount();
            } else {
              Toast.fire({
                icon: "error",
                title: "編輯失敗",
                text: res.data.error
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
            }
          })
          .catch(error => {
            console.error(error);
            this.$root.$emit("bv::hide::modal", "modalSalesModal", "#btnShow");
          });
      } else {
        Account.create(newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "新增成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalSalesModal",
                "#btnShow"
              );
              this.getAccount();
            } else {
              if (res.data.validated_message.telephone.length) {
                this.state.telephone = false;
                this.invalidFeedbackTelephone =
                  res.data.validated_message.telephone[0];
              } else {
                Toast.fire({
                  icon: "error",
                  title: "新增失敗",
                  text: res.data.error
                });
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  }
};
</script>
